
import { useState, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { SermonPlan, SermonFormData } from "@/hooks/sermon-plans/types";

interface UseSermonFormStateProps {
  form: UseFormReturn<SermonFormData>;
  currentSermonPlan: SermonPlan | null;
  initialFormData: SermonFormData | null;
  open: boolean;
}

export function useSermonFormState({ 
  form, 
  currentSermonPlan, 
  initialFormData, 
  open 
}: UseSermonFormStateProps) {
  const [date, setDate] = useState<Date | undefined>(
    currentSermonPlan?.planned_date ? new Date(currentSermonPlan.planned_date) : 
    initialFormData?.planned_date ? new Date(initialFormData.planned_date) : undefined
  );

  // Reset form when the dialog opens or currentSermonPlan/initialFormData changes
  useEffect(() => {
    if (open) {
      if (currentSermonPlan) {
        form.reset({
          title: currentSermonPlan.title || "",
          scripture_reference: currentSermonPlan.scripture_reference || "",
          notes: currentSermonPlan.notes || "",
          planned_date: currentSermonPlan.planned_date || "",
          theme: currentSermonPlan.theme || "",
          target_duration: currentSermonPlan.target_duration || "30",
          key_points: currentSermonPlan.key_points || "",
          sermon_type: currentSermonPlan.sermon_type || "Expository",
          congregation_id: currentSermonPlan.congregation_id || ""
        });
        
        if (currentSermonPlan.planned_date) {
          setDate(new Date(currentSermonPlan.planned_date));
        }
      } else if (initialFormData) {
        // Use the initial form data if provided
        form.reset({
          title: initialFormData.title || "",
          scripture_reference: initialFormData.scripture_reference || "",
          notes: initialFormData.notes || "",
          planned_date: initialFormData.planned_date || "",
          theme: initialFormData.theme || "",
          target_duration: initialFormData.target_duration || "30",
          key_points: initialFormData.key_points || "",
          sermon_type: initialFormData.sermon_type || "Expository",
          congregation_id: initialFormData.congregation_id || ""
        });
        
        if (initialFormData.planned_date) {
          setDate(new Date(initialFormData.planned_date));
        }
      } else {
        // Reset form when creating a new sermon plan
        form.reset({
          title: "",
          scripture_reference: "",
          notes: "",
          planned_date: "",
          theme: "",
          target_duration: "30",
          key_points: "",
          sermon_type: "Expository",
          congregation_id: ""
        });
        setDate(undefined);
      }
    }
  }, [currentSermonPlan, initialFormData, form, open]);

  return { date, setDate };
}
